import React from 'react';
import { Shield, Zap, Target, Heart } from 'lucide-react';
export function DoSomeMartialArtsWhyMartialArts() {
  return <section className="py-24 bg-paper border-b border-subtle-gray" data-id="element-1000">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1001">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-1002">
          <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-1003">
            Why Now
          </div>
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-1004">
            Why Try Martial Arts?
          </h2>
          <p className="text-lg text-gray-warm" data-id="element-1005">
            People come to Storm for different reasons — fitness, confidence, a
            positive activity for the kids, a skill to learn, or simply
            something different than a gym. Whatever brings you in, martial arts
            gives you more than you came for.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1006">
          {[{
          icon: Shield,
          title: 'Confidence',
          desc: 'Stand taller, speak up, and trust yourself in everyday situations — at any age.'
        }, {
          icon: Zap,
          title: 'Real Fitness',
          desc: 'Cardio, strength, flexibility, and balance built into every class — no separate gym needed.'
        }, {
          icon: Target,
          title: 'Focus & Discipline',
          desc: 'Structured training builds attention and follow-through that carries into school, work, and home.'
        }, {
          icon: Heart,
          title: 'Self-Defense Awareness',
          desc: 'Practical safety habits and awareness skills you can actually use — for kids and adults.'
        }].map((b, i) => <div key={i} className="bg-off-white border border-subtle-gray rounded-2xl p-6 flex flex-col gap-3" data-id="element-1007">
              <div className="w-12 h-12 bg-storm-red/10 rounded-xl flex items-center justify-center text-storm-red" data-id="element-1008">
                <b.icon className="w-6 h-6" data-id="element-1009" />
              </div>
              <h3 className="text-lg text-ink leading-tight" data-id="element-1010">{b.title}</h3>
              <p className="text-gray-warm text-sm leading-relaxed" data-id="element-1011">{b.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}